import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import InternetIssue from '../../components/InternetIssue/InternetIssue'
import LoaderNew from '../../components/LoaderNew/LoaderNew'
import {
    HIDE_TIMER,
    UPDATE_LOADING_PERCENT,
    UPDATE_ANALYTICS,
    UPDATE_MOCK_TEST_SUBMIT,
    UPDATE_GLOBAL_QUERY_PARAMS,
    UPDATE_IP_ADDRESS,
} from '../../constants/actionTypes'
import IacstResult from './IacstResultUI'
import useInstructionsData from '../InstructionsPage/useInstructionsData'
import useResultData from './useResultData'

const mapStateToProps = (state) => ({
    queryparam: state.queryparam,
    instructions: state.instructions,
    loading_percent: state.loading_percent,
    testStatus: state.testStatus,
})

const mapDispatchToProps = (dispatch) => ({
    setMockTestSubmit: (payload) =>
        dispatch({ type: UPDATE_MOCK_TEST_SUBMIT, payload }),
    hideTimer: (payload) => dispatch({ type: HIDE_TIMER, payload }),
    setAnalytics: (payload) => dispatch({ type: UPDATE_ANALYTICS, payload }),
    setLoadingPercent: (payload) =>
        dispatch({ type: UPDATE_LOADING_PERCENT, payload }),
    setQueryParam: (payload) =>
        dispatch({ type: UPDATE_GLOBAL_QUERY_PARAMS, payload }),
    setIpAddress: (payload) => dispatch({ type: UPDATE_IP_ADDRESS, payload }),
})

const Results = (props) => {
    const { t, i18n } = useTranslation()
    const {
        loading,
        fetchData: fetchInstructionsData,
        isError: isInstructionsError,
        errorMsg: instructionsErrorMsg,
    } = useInstructionsData(props)
    const {
        redirectToAnalytics,
        redirectToSuccess,
        isError,
        errorMsg,
        resultData,
        fetchData,
    } = useResultData(props)

    useEffect(() => {
        if (
            !props.instructions ||
            !props.instructions.testData ||
            !Object.keys(props.instructions.testData).length
        ) {
            fetchInstructionsData(props)
        } else if (!resultData || !Object.keys(resultData).length) {
            fetchData()
        }
    }, [props.instructions])

    if (isError || isInstructionsError) {
        localStorage.setItem('percent', '0')
        return (
            <InternetIssue
                redirectToInstruction
                message={
                    errorMsg || instructionsErrorMsg
                        ? errorMsg || instructionsErrorMsg
                        : t('Something Went Wrong')
                }
            />
        )
    }

    if (
        loading ||
        !props.instructions ||
        !props.instructions.testData ||
        !Object.keys(props.instructions.testData).length
    ) {
        return <p>loading ...</p>
    }
    if (redirectToAnalytics) {
        return <Redirect to="/analytics" />
    }

    if (redirectToSuccess) {
        props.setLoadingPercent(0)
        return <Redirect to="/success" />
    }
    // Don't show iacst result page as of now, redirect to iacst dashboard after submit
    // if (
    //     resultData &&
    //     typeof resultData === 'object' &&
    //     resultData.result_status !== null
    // ) {
    //     return <IacstResult props={props} resultData={resultData} />
    // }
    return (
        <LoaderNew
            done={props.loading_percent}
            title1={
                'testData' in props.instructions
                    ? props.instructions.testData?.title
                        ? props.instructions.testData?.title[i18n.language]
                        : ''
                    : null
            }
            title2={t('Your result and scholarship are being computed,')}
            title3={t('It takes around 2 minutes for the results to be available.')}
            title4={t('PLEASE DO NOT CLOSE THE BROWSER')}
        />
    )
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Results))
